<template>
  <div class="DevelopmentPath">
    <div
      class="box_info wow fadeInUp animated"
      v-for="(item, index) in resList"
      :key="'box_info' + index"
    >
      <div class="infoAvatar">
        <img :src="item.imageUrl" />
      </div>
      <div class="infoCont">
        <div class="infoTitle">{{ item.imageName }}</div>
        <div class="infoText">
          {{ item.imageDesc }}
        </div>
      </div>
    </div>
    <div ref="TimelineContent" class="box_Timeline wow fadeInUp animated">
      <i class="t_line"></i>
      <div class="decoration"></div>
      <div v-if="showBtnDetails" class="btn_details" @click="OnViewMore">
        查看更多
      </div>
      <div
        class="item_Timeline clear"
        v-for="(item, index) in timelineList"
        :key="'Timeline' + index"
        :ref="'Timeline' + index"
      >
        <div :class="[index % 2 == 1 ? 'i_right' : 'i_left', 'event']">
          <div class="i_time">{{ item.year.substring(0, 4) }}年</div>
          <div class="i_desc" v-html="item.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
if (process.browser) {
  var { WOW } = require("wowjs");
}
export default {
  name: "DevelopmentPath",
  data() {
    return {
      showBtnDetails: false,
      total: 1, // 总数
      pageNo: 1, // 当前页
      pageSize: 100000, // 每页显示条数
      t_lineHeight: "10px",
      // otherTimeLineList: [
      //   {
      //     time: "2005年",
      //     desc: "广州市黄埔化工厂获颁《中华人民共和国药品GMP证书》，成为国内樟脑和冰片行业中首个通过GMP认证的厂家。",
      //   },
      //   {
      //     time: "2004年",
      //     desc: "广州市黄埔化工厂成为国内首家通过原料药樟脑和冰片GMP现场认证的企业。",
      //   },
      //   {
      //     time: "2002年",
      //     desc: "企业通过了ISO9001:2000质量管理体系认证。",
      //   },
      //   {
      //     time: "1999年",
      //     desc: "“广达”牌合成樟脑荣获广东省优质产品称号。",
      //   },
      //   {
      //     time: "1998年",
      //     desc: "“广达”牌合成樟脑入选广州市名牌产品。",
      //   },
      //   {
      //     time: "1986年",
      //     desc: "“广达”牌合成樟脑荣获广东省优质产品称号。",
      //   },
      //   {
      //     time: "1985年",
      //     desc: "“广达”牌合成樟脑（第5类）医药级和（第1类）工业级获得商标注册；“三春”牌商标及图案获得商标注册。",
      //   },
      //   {
      //     time: "1982年",
      //     desc: "合成樟脑荣获国家化工部优质产品称号。",
      //   },
      //   {
      //     time: "1981年",
      //     desc: "“白雪”牌冰片（第五类）医药级获得商标注册。",
      //   },
      //   {
      //     time: "1980年",
      //     desc: "合成樟脑荣获广东省优质产品称号。",
      //   },
      //   {
      //     time: "1968年",
      //     desc: "合成樟脑生产线投产，生产能力为200吨/年。",
      //   },
      //   {
      //     time: "1965年",
      //     desc: "其安化工厂开始搬迁至广州市黄埔区菠萝庙，并更名为“广州市黄埔化工厂”，除了继续生产冰片，还新增了合成樟脑生产线。",
      //   },
      //   {
      //     time: "1956年",
      //     desc: "国家实行公私合营，私营其安化工厂更名为“公私合营其安化工厂”。",
      //   },
      //   {
      //     time: "1950年",
      //     desc: "其安化学工业社迁至广州市丛桂路，更名为“私营其安化工厂”。",
      //   },
      // ],
      // timelineList: [
      //   {
      //     time: "2020年",
      //     desc: "梧州黄埔化工药业有限公司营业收入17000万元，利润总额突破3000万元，纳税近1000万元，拥有专利7项。企业连续三年各项生产经营成绩亮丽，创造了企业发展新的历史。",
      //   },
      //   {
      //     time: "2018年",
      //     desc: "梧州黄埔化工药业有限公司完成1.6亿元营业收入，营业利润突破2500万元，纳税近500万元，创造企业发展新的历史。",
      //   },
      //   {
      //     time: "2018年",
      //     desc: "3月份首次缴纳建厂以来的增值税。",
      //   },
      //   {
      //     time: "2018年",
      //     desc: "1月以来，企业运营势头良好，工业总产值、主营业务收入和利润保持高位水平。",
      //   },
      //   {
      //     time: "2017年",
      //     desc: "实现新工厂首次月度扭亏为盈，2017年度实现135.16万元利润，为实现企业正常运营迈出坚实一步。",
      //   },
      //   {
      //     time: "2015年",
      //     desc: "取得药品GMP证书。",
      //   },
      //   {
      //     time: "2015年",
      //     desc: "获得药监部门批准",
      //   },
      //   {
      //     time: "2014年",
      //     desc: "生产出冰片合格产品。期间不断开展生产工艺调试，同时进行药品批准文号转移申请工作",
      //   },
      //   {
      //     time: "2014年",
      //     desc: "冰片投料试生产。",
      //   },
      //   {
      //     time: "2014年",
      //     desc: "生产出樟脑合格产品。",
      //   },
      //   {
      //     time: "2013年",
      //     desc: "合成樟脑投料试生产",
      //   },
      //   {
      //     time: "2011年",
      //     desc: "新厂开工建设，广州黄埔化工有限公司2012年1月中旬停产，主要的生产技术、经营干部和车间生产骨干加入梧州黄埔团队，成为新公司的中坚力量。",
      //   },
      //   {
      //     time: "2011年",
      //     desc: "顺应广州“退二进三”城市发展需要，梧州黄埔化工药业有限公司在中国最著名松香产区广西梧州奠基。",
      //   },
      //   {
      //     time: "2010年",
      //     desc: "梧州黄埔化工药业有限公司注册成立，广州黄埔化工有限公司以现金和品牌占股51%，广西梧州松脂股份有限公司以现金占股49%。新工厂设计产能为合成樟脑3000吨/年、冰片800吨/年。",
      //   },
      //   {
      //     time: "2008年",
      //     desc: "广州市黄埔化工厂通过引入民营资本以增资扩股形式进行混合所有制企业改革，企业名称由广州市黄埔化工厂变更为“广州黄埔化工有限公司”，企业由工厂制变为公司制。",
      //   },
      // ],
      resTimelineList: [],
      timelineList: [],
      resList: [],
    };
  },
  mounted() {
    if (process.browser) {
      new WOW({
        live: false,
        offset: 0,
      }).init();
    }
    this.getInfoList();
    this.getAboutusMemorabiliaList();
    // console.log(this.$refs.TimelineContent.clientHeight)
    // this.t_lineHeight= this.$refs.TimelineContent.clientHeight-90+'px'
  },
  methods: {
    async OnViewMore() {
      // this.resTimelineList = [...this.timelineList, ...this.otherTimeLineList];
      // 该接口没分页
      // this.pageSize = this.total;
      // this.getAboutusMemorabiliaList();
      this.showBtnDetails = false;
      this.timelineList = this.resTimelineList;
    },
    // 获取创始人简介图片
    async getInfoList() {
      let res = await this.$request.getImageManageList({
        columnType: 14,
        pageNo: this.pageNo,
        pageSize:1
      });
      // 图片增加相关域名
      res.rows.map((val, index) => {
        val.imageUrl = this.$store.state.baseUrl + val.imageUrl;
      });
      this.resList = res.rows;
      // 大图预览功能重置刷新
      this.$previewRefresh();
    },
    // 获取大事件事件
    async getAboutusMemorabiliaList() {
      let res = await this.$request.getAboutusMemorabiliaList({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      });
      this.resTimelineList = JSON.parse(JSON.stringify(res.rows));
      this.timelineList = res.rows.slice(0, 4);
      this.total = res.total;
      this.pageSize = res.total;
      this.showBtnDetails = res.total - 0 > 4;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/common.scss";
.DevelopmentPath {
  width: $contWidth;
  margin: 0 auto;
  padding: 0 0 5.21vw 0;
  // overflow: hidden;
  .decoration {
    display: block;
    width: 5.21vw;
    height: 5.21vw;
    border-radius: 50%;
    border: 3.13vw solid #eceef2;
    position: absolute;
    top: 50%;
    right: -10.42vw;
    margin: -4.17vw 0 0 0;
    z-index: 0;
  }
  .box_info {
    display: flex;
    margin: 2.6vw auto 0;
    width: 72.92vw;
    margin: 0 0 3.13vw 0;
    // background: #eef3f9;
    // height: 12.6vw;
    background: url("../../assets/images/company/DevelopmentPath/infoImgBg.png")
      no-repeat;
    background-size: 100% auto;
    .infoAvatar {
      width: 9.38vw;
      height: 9.38vw;
      margin: 1.56vw 2.6vw;
      border: 0.21vw solid #4382c8;
      border-radius: 50%;
      overflow: hidden;
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .infoCont {
      flex: 1;
      box-sizing: border-box;
      padding: 2.08vw 2.6vw 0 0;
      .infoTitle {
        font-size: 0.83vw;
        font-weight: bold;
        color: #333;
        padding: 0 0 0 0.52vw;
        border-left: 0.21vw solid #83bb26;
      }
      .infoText {
        font-size: 0.83vw;
        line-height: 1.56vw;
        text-indent: 1.67vw;
        color: #333;
        padding: 1.04vw 0 0 0;
      }
    }
  }
  .box_Timeline {
    width: 72.92vw;
    position: relative;
    padding: 0 0 2.6vw 0;
    margin: 0 auto;
    // .t_line {
    //   display: block;
    //   width: 0.26vw;
    //   height: 100%;
    //   background-color: #acadae;
    //   position: absolute;
    //   top: 2.6vw;
    //   left: 50%;
    //   z-index: -2;
    //   margin: 0 0 0 -0.13vw;
    // }
    .item_Timeline {
      width: 72.92vw;
      margin: 0 auto;
      padding: 0 0 2.6vw 0;
      position: relative;
      &:last-child .event::after {
        display: none;
      }
      .event {
        width: 34.9vw - 3.13vw;
        min-height: 4.01vw - 1.46vw;
        padding: 0.73vw 1.56vw;
        background-color: #ffffff;
        box-shadow: 0vw 0vw 0.16vw 0vw rgba(0, 0, 0, 0.32);
        border-radius: 0.52vw;
        position: relative;
        &::before {
          content: "";
          display: block;
          width: 1.46vw;
          height: 1.46vw;
          border-radius: 50%;
          background-color: #83bb26;
          position: absolute;
          top: 0;
          z-index: 6;
        }
        &::after {
          content: "";
          display: block;
          width: 0.26vw;
          height: 100%;
          padding: 0 0 2.6vw 0;
          background-color: #acadae;
          position: absolute;
          top: 0;
          bottom: auto;
          z-index: -1;
        }
        &.i_left {
          float: left;
          &::before {
            right: -2.29vw;
          }
          &::after {
            right: -1.72vw;
          }
        }
        &.i_right {
          float: right;
          &::before {
            left: -2.29vw;
          }
          &::after {
            left: -1.72vw;
          }
        }
        .i_time {
          font-size: 0.83vw;
          line-height: 1.25vw;
          color: #83bb26;
        }
        .i_desc {
          font-size: 0.83vw;
          line-height: 1.25vw;
          color: #333333;
        }
      }
    }
    .btn_details {
      width: 6.67vw;
      height: 2.19vw;
      line-height: 2.19vw;
      text-align: center;
      font-size: 0.83vw;
      color: #ffffff;
      margin: 0 auto;
      background-color: #83bb26;
      border: 0.05vw solid #83bb26;
      cursor: pointer;
      transition: 0.3s all;
      position: absolute;
      bottom: 0;
      left: 50%;
      margin: 0 0 0 -3.33vw;
      // &:hover {
      //   color: #83bb26;
      //   background-color: #fff;
      // }
    }
  }
}
@media (min-width: 1920px) {
  .DevelopmentPath {
    width: $contWidth;
    margin: 0 auto;
    padding: 0 0 100px 0;
    // overflow: hidden;
    .decoration {
      display: block;
      width: 100px;
      height: 100px;
      border-radius: 50%;
      border: 60px solid #eceef2;
      position: absolute;
      top: 50%;
      right: -200px;
      margin: -80px 0 0 0;
      z-index: 0;
    }
    .box_info {
      display: flex;
      margin: 50px auto 0;
      width: 1400px;
      margin: 0 0 60px 0;
      background: #eef3f9;
      // height: 242px;
      background: url("../../assets/images/company/DevelopmentPath/infoImgBg.png")
        no-repeat;
      background-size: 100% auto;
      .infoAvatar {
        width: 180px;
        height: 180px;
        margin: 30px 50px;
        border: 4px solid #4382c8;
        border-radius: 50%;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .infoCont {
        flex: 1;
        box-sizing: border-box;
        padding: 40px 50px 0 0;
        .infoTitle {
          font-size: 16px;
          font-weight: bold;
          color: #333;
          padding: 0 0 0 10px;
          border-left: 4px solid #83bb26;
        }
        .infoText {
          font-size: 16px;
          line-height: 30px;
          text-indent: 32px;
          color: #333;
          padding: 20px 0 0 0;
        }
      }
    }
    .box_Timeline {
      width: 1400px;
      position: relative;
      padding: 0 0 50px 0;
      margin: 0 auto;
      // .t_line {
      //   display: block;
      //   width: 5px;
      //   height: 100%;
      //   background-color: #acadae;
      //   position: absolute;
      //   top: 50px;
      //   left: 50%;
      //   z-index: -2;
      //   margin: 0 0 0 -2.5px;
      // }
      .item_Timeline {
        width: 1400px;
        margin: 0 auto;
        padding: 0 0 50px 0;
        position: relative;
        &:last-child .event::after {
          display: none;
        }
        .event {
          width: 670px - 60px;
          min-height: 77px - 28px;
          padding: 14px 30px;
          background-color: #ffffff;
          box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.32);
          border-radius: 10px;
          position: relative;
          &::before {
            content: "";
            display: block;
            width: 28px;
            height: 28px;
            border-radius: 50%;
            background-color: #83bb26;
            position: absolute;
            top: 0;
            z-index: 6;
          }
          &::after {
            content: "";
            display: block;
            width: 5px;
            height: 100%;
            padding: 0 0 50px 0;
            background-color: #acadae;
            position: absolute;
            top: 0;
            bottom: auto;
            z-index: -1;
          }
          &.i_left {
            float: left;
            &::before {
              right: -44px;
            }
            &::after {
              right: -33px;
            }
          }
          &.i_right {
            float: right;
            &::before {
              left: -44px;
            }
            &::after {
              left: -33px;
            }
          }
          .i_time {
            font-size: 16px;
            line-height: 24px;
            color: #83bb26;
          }
          .i_desc {
            font-size: 16px;
            line-height: 24px;
            color: #333333;
          }
        }
      }
      .btn_details {
        width: 128px;
        height: 42px;
        line-height: 42px;
        text-align: center;
        font-size: 16px;
        color: #ffffff;
        margin: 0 auto;
        background-color: #83bb26;
        border: 1px solid #83bb26;
        cursor: pointer;
        transition: 0.3s all;
        position: absolute;
        bottom: 0;
        left: 50%;
        margin: 0 0 0 -64px;
        // &:hover {
        //   color: #83bb26;
        //   background-color: #fff;
        // }
      }
    }
  }
}
</style>